import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { PictureAsPdf as PdfIcon } from '@mui/icons-material';

export default function Streitwertkatalog() {
  return (
    <Box sx={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      p: 3 
    }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Streitwertkatalog
        </Typography>
        
        <Typography paragraph>
          In Verfahren vor den Sozialgerichten werden Gerichtsgebühren nach dem Gerichtskostengesetz (GKG) erhoben. 
          Die Höhe der Gerichtsgebühren richtet sich nach dem Streitwert, der vom Gericht festgesetzt wird. Der 
          Streitwert orientiert sich dabei am wirtschaftlichen Interesse des Klägers und dem Ziel des Verfahrens.
        </Typography>

        <Typography paragraph>
          Der Streitwertkatalog enthält Empfehlungen für die Festsetzung von Streitwerten in sozialgerichtlichen 
          Verfahren. Diese Empfehlungen dienen als Orientierungshilfe für eine einheitliche Streitwertfestsetzung. 
          Die gerichtliche Festsetzung des Streitwerts ist auch für die Berechnung der Rechtsanwaltsgebühren nach 
          dem Rechtsanwaltsvergütungsgesetz (RVG) maßgebend.
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            startIcon={<PdfIcon />}
            href="/downloads/Streitwertkatalog_Maerz_2017.pdf"
            target="_blank"
          >
            Streitwertkatalog (März 2017)
          </Button>
        </Box>
      </Paper>
    </Box>
  );
} 